import { ListItem } from '@app/shared/ui/molecules/Admin/Withdrawals';
import type { AdminWithdrawal } from '@app/store/slices/admin/adminTypes';

interface ListSectionProps {
  items: AdminWithdrawal[];
}

export function ListSection({ items }: ListSectionProps) {
  return (
    <ul className="flex flex-col gap-2 px-3">
      {items.map((item) => (
        <ListItem
          key={item.id}
          withdrawalId={item.id}
          telegramTag={item.user?.telegramUsername}
          telegramId={item.user?.telegramId}
          status={item.status}
          amount={item.payoutAmount}
        />
      ))}
    </ul>
  );
}
